import {expectOneOf, HttpClient, POST, ServerValidationResult} from '@raison/network-facade';
import {AccountId} from '@raison/types';
import BigNumber from 'bignumber.js';
import {CryptoCurrencyType} from '~/entities/currencies';
import {Issues} from '~/library/form-models.v1';
import {SendTxTravelRuleValues} from '../ui/SendTrTx';

interface Values extends SendTxTravelRuleValues {
    amount: BigNumber;
    address: string;
    comment: string;
}

export async function submitTravelRuleReview(
    http: HttpClient,
    accountId: AccountId,
    accountType: CryptoCurrencyType,
    values: Values
) {
    const url = (() => {
        switch (accountType) {
            case 'crypto':
                return `v1/operations/${accountId}/send_crypto_tr/review`;
            case 'stablecoin':
                return `v1/operations/${accountId}/send_token_tr/review`;
        }
    })();

    const body = {
        amount: values.amount,
        beneficiary_wallet: values.address,
        comment: values.comment,
        beneficiary_type: values.participantType,
        beneficiary_name: values.participantName,
        // FIXME: (non critical) participantCountry is typed as nullable but server will not accept null
        beneficiary_country: values.participantCountry,
        beneficiary_town: values.participantTown,
        beneficiary_address: values.participantAddress,
        ...(values.walletVasp && values.walletType === 'vasp'
            ? {wallet_type: 'vasp', wallet_vasp_id: values.walletVasp.id}
            : {wallet_type: 'unhosted'}),
    };

    return await http(url, POST(body)).then(
        expectOneOf({
            200: null,
            201: null,
            401: null,
            400: SendTravelRuleReviewIssues,
        })
    );
}

export type SendTravelRuleReviewIssues = typeof SendTravelRuleReviewIssues.infer;
export const SendTravelRuleReviewIssues = ServerValidationResult.pipe(
    (i): Issues<Values> => ({
        address: i.beneficiary_wallet,
        comment: i.comment,
        amount: i.amount,
        participantType: i.beneficiary_type,
        participantName: i.beneficiary_name,
        participantCountry: i.beneficiary_country,
        participantTown: i.beneficiary_town,
        participantAddress: i.beneficiary_address,
        walletType: i.wallet_type,
        walletVasp: i.wallet_vasp_id,
    })
);
